var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Fragment } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Button, Dialog, DialogError, DialogLoading } from '@pocketlaw/tetris';
import { Formik } from 'formik';
import { Fieldset } from '../Fieldset';
import { StyledForm } from './styled';
function FormDialog(props) {
    const { children, initialValues, onClose, onRefetch, size, state, 'aria-labelledby': ariaLabelledBy, 'aria-describedby': ariaDescribedBy } = props, rest = __rest(props, ["children", "initialValues", "onClose", "onRefetch", "size", "state", 'aria-labelledby', 'aria-describedby']);
    const { error, loading } = state || {};
    if (loading) {
        return (<Dialog>
        <DialogLoading />
      </Dialog>);
    }
    if (error) {
        return (<Dialog>
        <DialogError title={t({ message: 'Error', comment: 'Generic form dialog error' })} description={t({
                message: 'Something went wrong while loading the dialog, please try again.',
                comment: 'Generic form dialog error',
            })} actions={<Fragment>
              <Button type="button" appearance="secondary" size="small" onClick={onClose}>
                <Trans comment="Generic form dialog error">Close</Trans>
              </Button>
              {onRefetch && (<Button type="button" size="small" onClick={() => onRefetch()}>
                  <Trans comment="Generic form dialog error">Try again</Trans>
                </Button>)}
            </Fragment>}/>
      </Dialog>);
    }
    return (<Formik initialValues={initialValues} {...rest}>
      <Dialog size={size} onClose={onClose} aria-labelledby={ariaLabelledBy} aria-describedby={ariaDescribedBy}>
        <StyledForm>
          <Fieldset>{children}</Fieldset>
        </StyledForm>
      </Dialog>
    </Formik>);
}
export { FormDialog };
